import ConnectyCube from './ConnectyCube';

const connectycube = new ConnectyCube();
connectycube.ConnectyCube = ConnectyCube;

export default connectycube;
